import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=c51f9e2c&scoped=true&"
import script from "./OrderTable.vue?vue&type=script&lang=js&"
export * from "./OrderTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderTable.vue?vue&type=style&index=0&id=c51f9e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51f9e2c",
  null
  
)

export default component.exports